module.exports = __webpack_public_path__ + "static/media/LinkedIn.309ce38a.svg";